import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { privateRequest } from "services/privateRequest";
import { ERRORLOG } from "services/endPoints";

const pageSize = 25;

const formatToDDMMYYYY = (date) => {
  if (!date) return "";
  const d = new Date(date);
  const day = String(d.getDate()).padStart(2, "0");
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const year = d.getFullYear();
  return `${day}/${month}/${year}`;
};

export const fetchErrorLogs = createAsyncThunk(
  "errorLogs/fetchErrorLogs",
  async (_, { getState }) => {
    const { pageNo, fromDate, toDate } = getState().errorLog;

    const response = await privateRequest.get(ERRORLOG, {
      params: {
        fromDate: formatToDDMMYYYY(fromDate),
        toDate: formatToDDMMYYYY(toDate),
        pageNo,
        pageSize,
      },
    });

    return {
      logs: response?.data?.data?.data || [],
      total: response?.data?.data?.count?.total || 0,
    };
  }
);

const errorLogSlice = createSlice({
  name: "errorLog",
  initialState: {
    errorLogs: [],
    loader: false,
    total: 0,
    pageNo: 1,
    fromDate: null,
    toDate: null,
  },

  reducers: {
    setPageNo: (state, action) => {
      state.pageNo = action.payload;
    },
    setFromDate: (state, action) => {
      state.fromDate = action.payload;
      state.pageNo = 1;
    },
    setToDate: (state, action) => {
      state.toDate = action.payload;
      state.pageNo = 1;
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(fetchErrorLogs.pending, (state) => {
        state.loader = true;
      })
      .addCase(fetchErrorLogs.fulfilled, (state, action) => {
        state.loader = false;
        state.errorLogs = action.payload.logs;
        // state.errorLogs = action.payload.logs?.map((row, i) => ({ ...row, id: i + 1 }));
        state.total = action.payload.total;
      })
      .addCase(fetchErrorLogs.rejected, (state) => {
        state.loader = false;
      });
  },
});

export const { setPageNo, setFromDate, setToDate } = errorLogSlice.actions;

export default errorLogSlice.reducer;
